import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#2e7d32', // Green 800
            light: '#60ad5e',
            dark: '#005005',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#212121', // Grey 900
            light: '#484848',
            dark: '#000000',
            contrastText: '#ffffff',
        },
        background: {
            default: '#f4f6f8', // Slightly darker for contrast vs cards
            paper: '#ffffff',
        },
        text: {
            primary: '#1a1a1a',
            secondary: '#666666',
        },
        error: {
            main: '#d32f2f',
            light: '#ef5350',
        },
        success: {
            main: '#2e7d32',
        }
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 800,
            letterSpacing: '-1px',
        },
        h2: {
            fontWeight: 700,
            letterSpacing: '-0.5px',
        },
        h3: {
            fontWeight: 700,
        },
        h4: {
            fontWeight: 700,
        },
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
            letterSpacing: '0.2px',
        },
    },
    shape: {
        borderRadius: 16,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '50px',
                    padding: '10px 24px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
                    },
                },
                containedPrimary: {
                    background: 'linear-gradient(45deg, #2e7d32 30%, #43a047 90%)',
                },
                sizeLarge: {
                    padding: '14px 28px',
                    fontSize: '1rem',
                }
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '24px',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.04)',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    border: '1px solid rgba(0,0,0,0.05)',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0px 12px 24px rgba(0,0,0,0.08)',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                elevation0: {
                    border: '1px solid #e0e0e0',
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                },
            }
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '16px',
                    }
                }
            }
        }
    },
});

export default theme;
